import { useAuth } from '../../context/auth';
import React from 'react';
import { Route as RouterRoute, Redirect } from 'react-router-dom';
import Layout from './../../components/Layout';
import { GENERAL } from '../../constants/nav-routes';

const Route = (props) => {
  const { layout, path, Component, exact, isPrivate, redirect } = props;
  const { user } = useAuth();
  if (isPrivate && !user?.id) return <Redirect to={GENERAL.LOGIN} />;
  if (redirect) return <Redirect to={redirect} />;
  return (
    <RouterRoute path={path} {...props} exact={exact}>
      <Layout layout={layout} {...props}>
        <Component {...props} />
      </Layout>
    </RouterRoute>
  );
};

export default Route;
